import styled from 'styled-components'

const H1 = styled.h1`
  color: ${props => props.theme.colors.darkGray};
  font-weight: 600;
`

export default H1
